import {
  aggregationCompaniesSchema,
  aggregationEndDateTimeSchema,
  aggregationOutputPatternSchema,
  aggregationShopsSchema,
  aggregationStartDateTimeSchema,
  aggregationTerminalsSchema,
  aggregationWalletServicesSchema,
} from './aggregation';

import { TransactionAggregationCriteriaKey } from '@/types';
import {
  InferType,
  string,
  object,
} from '@/validations/custom-yup';

export const transactionAggregationCriteriaSchema = string<TransactionAggregationCriteriaKey>()
  .label('集計基準')
  .required(({ label }) => `${label}を選択してください。`);

export const transactionAggregationFilterSchema = object({
  walletServices: aggregationWalletServicesSchema,
  companies: aggregationCompaniesSchema,
  shops: aggregationShopsSchema,
  terminals: aggregationTerminalsSchema,
});

export type TransactionAggregationFilterSchema = InferType<typeof transactionAggregationFilterSchema>;

export const transactionAggregationUiFormSchema = object({
  startDateTime: aggregationStartDateTimeSchema,
  endDateTime: aggregationEndDateTimeSchema,
  criteria: transactionAggregationCriteriaSchema,
  filter: transactionAggregationFilterSchema,
  outputPattern: aggregationOutputPatternSchema,
});
export type TransactionAggregationUiFormSchema = InferType<typeof transactionAggregationUiFormSchema>;
